import { useState, useEffect } from "react";

const BASE = "https://support.gs-group.fr/api";
const h = () => ({ "Content-Type":"application/json", Authorization:"Bearer "+localStorage.getItem("nexo_token") });

export default function ICalExport({ T }) {
  const [url, setUrl]       = useState("");
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    fetch(`${BASE}/ical/token/me`, {headers:h()})
      .then(r=>r.json())
      .then(d=>{ if(d.url) setUrl(d.url); })
      .catch(()=>{})
      .finally(()=>setLoading(false));
  },[]);

  const copy = () => {
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(()=>setCopied(false),2500);
  };

  return (
    <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,padding:22}}>
      <div style={{fontSize:16,fontWeight:800,color:T.text,marginBottom:6}}>📅 Synchronisation Agenda</div>
      <div style={{fontSize:13,color:T.muted,marginBottom:18,lineHeight:1.7}}>
        Abonnez-vous à votre agenda d'interventions depuis Google Agenda, Apple Agenda ou Outlook.
        Le calendrier se met à jour automatiquement.
      </div>

      {loading ? (
        <div style={{color:T.muted,fontSize:13}}>⏳ Génération du lien...</div>
      ) : (
        <>
          {/* Lien iCal */}
          <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:"12px 14px",marginBottom:14}}>
            <div style={{fontSize:11,fontWeight:700,color:T.muted,marginBottom:6,textTransform:"uppercase",letterSpacing:"0.5px"}}>🔗 Lien d'abonnement iCal</div>
            <div style={{fontSize:11,color:T.accent,wordBreak:"break-all",fontFamily:"monospace",marginBottom:10,lineHeight:1.6}}>{url}</div>
            <button onClick={copy}
              style={{width:"100%",padding:"9px",borderRadius:9,background:copied?T.success:`${T.accent}20`,border:`1px solid ${copied?T.success:T.accent}`,color:copied?"#fff":T.accent,fontSize:13,fontWeight:700,cursor:"pointer",transition:"all 0.2s"}}>
              {copied?"✅ Lien copié !":"📋 Copier le lien"}
            </button>
          </div>

          {/* Instructions par agenda */}
          <div style={{display:"flex",flexDirection:"column",gap:10}}>

            {/* Google Agenda */}
            <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:14}}>
              <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:8,display:"flex",alignItems:"center",gap:8}}>
                <span style={{fontSize:18}}>📅</span> Google Agenda
              </div>
              <ol style={{fontSize:12,color:T.muted,lineHeight:2,paddingLeft:18}}>
                <li>Ouvrir <strong style={{color:T.text}}>calendar.google.com</strong></li>
                <li>Cliquer <strong style={{color:T.text}}>+ Autres agendas</strong> → <strong style={{color:T.text}}>Via une URL</strong></li>
                <li>Coller le lien iCal ci-dessus</li>
                <li>Cliquer <strong style={{color:T.text}}>Ajouter un agenda</strong></li>
              </ol>
              <a href={`https://calendar.google.com/calendar/r?cid=webcal://${url.replace("https://","")}`} target="_blank" rel="noreferrer"
                style={{display:"block",marginTop:8,padding:"8px",borderRadius:9,background:"#4285f420",border:"1px solid #4285f440",color:"#4285f4",fontSize:12,fontWeight:700,textAlign:"center",textDecoration:"none"}}>
                Ouvrir Google Agenda →
              </a>
            </div>

            {/* Apple Agenda */}
            <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:14}}>
              <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:8,display:"flex",alignItems:"center",gap:8}}>
                <span style={{fontSize:18}}>🍎</span> Apple Agenda (iPhone / Mac)
              </div>
              <ol style={{fontSize:12,color:T.muted,lineHeight:2,paddingLeft:18}}>
                <li>Ouvrir <strong style={{color:T.text}}>Calendrier</strong> sur Mac ou iPhone</li>
                <li>Menu <strong style={{color:T.text}}>Fichier</strong> → <strong style={{color:T.text}}>Nouvel abonnement de calendrier</strong></li>
                <li>Coller le lien iCal et cliquer <strong style={{color:T.text}}>S'abonner</strong></li>
              </ol>
              <a href={`webcal://${url.replace('https://','')}`}
                style={{display:"block",marginTop:8,padding:"8px",borderRadius:9,background:"#ff6b6b20",border:"1px solid #ff6b6b40",color:"#ff6b6b",fontSize:12,fontWeight:700,textAlign:"center",textDecoration:"none"}}>
                Ouvrir dans Apple Agenda →
              </a>
            </div>

            {/* Outlook */}
            <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:14}}>
              <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:8,display:"flex",alignItems:"center",gap:8}}>
                <span style={{fontSize:18}}>📧</span> Outlook
              </div>
              <ol style={{fontSize:12,color:T.muted,lineHeight:2,paddingLeft:18}}>
                <li>Ouvrir <strong style={{color:T.text}}>Outlook</strong> → <strong style={{color:T.text}}>Calendrier</strong></li>
                <li>Cliquer <strong style={{color:T.text}}>Ajouter un calendrier</strong> → <strong style={{color:T.text}}>Via Internet</strong></li>
                <li>Coller le lien iCal et valider</li>
              </ol>
            </div>
          </div>

          <div style={{marginTop:14,padding:"10px 14px",background:`${T.warning}15`,border:`1px solid ${T.warning}30`,borderRadius:10,fontSize:12,color:T.warning}}>
            ⚠️ Ce lien est personnel et privé — ne le partagez pas. Il donne accès à vos interventions.
          </div>
        </>
      )}
    </div>
  );
}
